import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

/**
 * A higher-order component that ensures the user is authenticated and has the required roles to access a route.
 * If the user is not authenticated, they are redirected to the login page.
 * If the user is authenticated but does not have the required roles, an access denied message is shown.
 */
const ProtectedRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/access-denied" />;
  }

  return children;
};

export default ProtectedRoute;
